export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }} className="inline-block cursor-pointer">
              <span className="font-heading text-2xl font-bold tracking-tight text-foreground-950">
                A&Z<span className="text-primary-500">.</span>
              </span>
              <span className="block text-sm font-medium text-foreground-600 mt-1">
                Schoonmaakdienst
              </span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              Professionele schoonmaak voor een frisse en hygiënische werkomgeving. Uw betrouwbare partner in schoonmaak door heel Nederland.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
              Navigatie
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { id: 'diensten', label: 'Onze diensten' },
                { id: 'over-ons', label: 'Over ons' },
                { id: 'voor-wie', label: 'Voor wie' },
                { id: 'contact', label: 'Contact' },
              ].map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.id); }}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
              Contact
            </h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-600">
              <a href="tel://+31641405833" className="flex items-center gap-3 hover:text-primary-500 transition-colors cursor-pointer group">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-phone-line"></i>
                </span>
                06 41 40 58 33
              </a>
              <a href="mailto:info@a-z-schoon.nl" className="flex items-center gap-3 hover:text-primary-500 transition-colors cursor-pointer group">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-mail-line"></i>
                </span>
                info@a-z-schoon.nl
              </a>
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-map-pin-line"></i>
                </span>
                Landelijk actief in heel Nederland
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} A&Z Schoonmaakdienst. Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              Privacyverklaring
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              Algemene voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}